<script setup lang="ts">
const props = defineProps<{ idealLink?: IdealLink }>()
</script>

<template>
  <DonateContentButton
    v-if="props.idealLink"
    :to="props.idealLink.href"
    :label="props.idealLink.label"
    icon="bx:euro"
  />
</template>
